import { IReplenishmentStatus } from "./IReplenishmentStatus"

export const ReplenishmentStatus: IReplenishmentStatus = {
  NEW: ["Загрузка документов", "Загрузите документы"],
  DOC: ["Проверьте документы", "Проверяем документы"],
  DOC_NAC: ["Документы на доработке", "Необходимо исправить ошибки"],
  DOC_ACC: ["Документы приняты", "Запросить курс"],
  CR_REQ: ["Запрос курса", "Формируем курс"],
  CR_AWT: ["Курс отправлен", "Курс сформирован"],
  CR_ACC: ["Ожидаем оплату", "Оплатите счет"],
  CR_NAC: ["Курс отклонен", "Повторный запрос курса"],
  SLIP_SENT: ["Проверьте оплату", "Проверяем оплату"],
  BILL_PAID: ["Проверьте оплату", "Проверяем оплату"],
  CR_FIX: ["Зафиксируйте курс", "Фиксируем курс"],
  DONE: ["Зачислены на счет", "Зачислены на счет"],
  ARCHIVED: ["Архив", ""]
}
